<div class="modern-home-page" 
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'">
  <!-- Hero Section - Layouts 1-3: Regular layouts with header inside hero -->
  <div class="website-element hero-element" 
       *ngIf="isElementVisible('hero') && (getHeroLayout() === 'layout_1' || getHeroLayout() === 'layout_2' || getHeroLayout() === 'layout_3')"
       [class.selected]="getElementByIndex(1)?.selected"
       [class.layout-1]="getHeroLayout() === 'layout_1'"
       [class.layout-2]="getHeroLayout() === 'layout_2'"
       [class.layout-3]="getHeroLayout() === 'layout_3'"
       [style.background-color]="getHeroBackgroundColor()">
    
    <!-- Header Section inside Hero -->
    <div class="hero-header-wrapper" (click)="onHeaderClick()">
      <app-modern-page-header
        *ngIf="isElementVisible('header')"
        [logo]="getHeaderLogo()"
        [navigation]="getHeaderNavigation()"
        [ctaButton]="getHeaderCTAButton()"
        [visible]="true"
        [clickable]="true"
        [selected]="isHeaderSelected()"
        [headingColor]="headingColor"
        [headingFont]="headingFont"
        [backgroundColor]="getHeaderBackgroundColor()"
        [deviceType]="deviceType"
        (headerClick)="onHeaderClick()"
        (navigationClick)="onNavigationClick($event)">
      </app-modern-page-header>
    </div>

    <!-- Hero Content -->
    <div class="hero-content-wrapper" (click)="onElementClick(getElementByIndex(1))">
      <!-- Layout 1: Text Left, Image Right -->
      <app-hero-layout-1-preview
        *ngIf="getHeroLayout() === 'layout_1'"
        [data]="getHeroLayoutData()"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
        (buttonClick)="onButtonClick($event.link, $event.event)">
      </app-hero-layout-1-preview>

      <!-- Layout 2: Image Top, Text Centered -->
      <app-hero-layout-2-preview
        *ngIf="getHeroLayout() === 'layout_2'"
        [data]="getHeroLayoutData()"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
        (buttonClick)="onButtonClick($event.link, $event.event)">
      </app-hero-layout-2-preview>

      <!-- Layout 3: Image Left, Text Right -->
      <app-hero-layout-3-preview
        *ngIf="getHeroLayout() === 'layout_3'"
        [data]="getHeroLayoutData()"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
        (buttonClick)="onButtonClick($event.link, $event.event)">
      </app-hero-layout-3-preview>
    </div>
  </div>

  <!-- Header Section (separate for layouts 4-6) -->
  <div class="hero-header-wrapper"
       *ngIf="isElementVisible('hero') && (getHeroLayout() === 'layout_4' || getHeroLayout() === 'layout_5' || getHeroLayout() === 'layout_6') && isElementVisible('header')"
       (click)="onHeaderClick()">
    <app-modern-page-header
      [logo]="getHeaderLogo()"
      [navigation]="getHeaderNavigation()"
      [ctaButton]="getHeaderCTAButton()"
      [visible]="true"
      [clickable]="true"
      [selected]="isHeaderSelected()"
      [headingColor]="headingColor"
      [headingFont]="headingFont"
      [backgroundColor]="getHeaderBackgroundColor()"
      [deviceType]="deviceType"
      (headerClick)="onHeaderClick()"
      (navigationClick)="onNavigationClick($event)">
    </app-modern-page-header>
  </div>

  <!-- Layout 4: Text at Top with Background Image -->
  <div class="website-element hero-element" 
       *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_4'"
       [class.selected]="getElementByIndex(1)?.selected"
       [class.layout-4]="true"
       (click)="onElementClick(getElementByIndex(1))">
    <app-hero-layout-4-preview
      [data]="getHeroLayoutData()"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-hero-layout-4-preview>
  </div>

  <!-- Layout 5: Text Vertically Centered with Background Image -->
  <div class="website-element hero-element" 
       *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_5'"
       [class.selected]="getElementByIndex(1)?.selected"
       [class.layout-5]="true"
       (click)="onElementClick(getElementByIndex(1))">
    <app-hero-layout-5-preview
      [data]="getHeroLayoutData()"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-hero-layout-5-preview>
  </div>

  <!-- Layout 6: Text Vertically Bottom with Background Image -->
  <div class="website-element hero-element" 
       *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_6'"
       [class.selected]="getElementByIndex(1)?.selected"
       [class.layout-6]="true"
       (click)="onElementClick(getElementByIndex(1))">
    <app-hero-layout-6-preview
      [data]="getHeroLayoutData()"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(getElementByIndex(1) || null)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-hero-layout-6-preview>
  </div>

  <!-- Hero Section - Layout 7: Modern Template Style (Same as Layout 1) -->
  <section class="hero-section hero-layout-1" 
           *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_7'"
           [class.selected]="getElementByIndex(1)?.selected"
           [style.background-image]="'url(' + (getElementByIndex(1)?.content?.imageUrl || 'assets/images/hero-placeholder.png') + ')'"
           [style.background-color]="getHeroBackgroundColor()"
           (click)="onElementClick(getElementByIndex(1))">
    
    <!-- Header Inside Hero -->
    <div class="hero-header-wrapper" (click)="onHeaderClick(); $event.stopPropagation()">
      <app-modern-page-header
        *ngIf="isElementVisible('header')"
        [logo]="getHeaderLogo()"
        [navigation]="getHeaderNavigation()"
        [ctaButton]="getHeaderCTAButton()"
        [visible]="true"
        [clickable]="true"
        [selected]="isHeaderSelected()"
        [headingColor]="headingColor"
        [headingFont]="headingFont"
        [backgroundColor]="getHeaderBackgroundColor()"
        [deviceType]="deviceType"
        (headerClick)="onHeaderClick()"
        (navigationClick)="onNavigationClick($event)">
      </app-modern-page-header>
    </div>

    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title" [style.color]="getHeadingColor()">{{ getTitleSafe(getElementByIndex(1)) }}</h1>
        <p class="hero-description" [style.color]="getParagraphColor()">{{ getDescriptionSafe(getElementByIndex(1)) }}</p>
        <button *ngIf="getElementByIndex(1)?.content?.buttonText" class="btn-primary"
                [style.background]="getPrimaryColor() || '#1B5BFF'"
                [style.--btn-bg]="getPrimaryColor() || '#1B5BFF'"
                [style.color]="getHeadingColor()"
                (click)="onButtonClick(getElementByIndex(1)?.content?.buttonLink, $event)">
          <span class="btn-primary-text">{{ getElementByIndex(1)?.content?.buttonText }}</span>
          <span class="btn-primary-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </div>
    </div>
  </section>

  <!-- Info/Welcome Section -->
  <section class="info-section" 
           *ngIf="isElementVisible('welcome')"
           [class.selected]="getWelcomeElement()?.selected"
           [style.background-color]="getSectionBackgroundColor(getWelcomeElement())"
           (click)="onElementClick(getWelcomeElement())">
    <div class="info-container">
      <div class="info-image">
        <img [src]="getWelcomeElement()?.content?.imageUrl || 'assets/images/info-placeholder.png'" 
             alt="Professional car care" />
      </div>
      <div class="info-content">
        <h2 class="info-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles(getWelcomeElement() || null)">{{ getTitleSafe(getWelcomeElement()) }}</h2>
        <p class="info-description"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getDescriptionSafe(getWelcomeElement()) }}</p>
        <button class="btn-primary"
                [style.background]="getPrimaryColor() || '#1B5BFF'"
                [style.--btn-bg]="getPrimaryColor() || '#1B5BFF'"
                [style.color]="getHeadingColor()"
                (click)="onButtonClick(getWelcomeElement()?.content?.buttonLink, $event)">
          <span class="btn-primary-text">{{ getWelcomeElement()?.content?.buttonText || 'Learn More' }}</span>
          <span class="btn-primary-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </div>
    </div>
  </section>

  <!-- Testimonials Section (Figma: horizontal scroll row) -->
  <section class="testimonials-section website-element testimonials-element"
           *ngIf="isElementVisible('testimonials')"
           [class.selected]="getElementByIndex(3)?.selected"
           [style.background-color]="getTestimonialsBackgroundColor()"
           (click)="onElementClick(getElementByIndex(3))">
    <div class="testimonials-container">
      <div class="testimonials-header">
        <span class="testimonials-eyebrow"
              [style.color]="getParagraphColor()"
              [style.font-family]="getBodyFont()">TESTIMONIAL</span>
        <h2 class="testimonials-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles(getElementByIndex(3) || null)">{{ getTestimonialsTitle() }}</h2>
        <p class="testimonials-subtitle"
           *ngIf="getTestimonialsSubtitle()"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getTestimonialsSubtitle() }}</p>
      </div>

      <div class="testimonials-scroll-wrapper">
        <div class="testimonials-scroll"
             #testimonialsScroll
             (scroll)="onTestimonialsScroll()">
          <div class="testimonials-track">
            <div class="testimonial-card"
                 *ngFor="let testimonial of getTestimonials(); trackBy: trackByTestimonialId">
              <div class="testimonial-card-top">
                <img [src]="testimonial.author?.avatar || 'assets/images/avatar-placeholder.png'"
                     [alt]="testimonial.author?.name"
                     class="testimonial-avatar" />
                <p class="testimonial-text"
                   [style.color]="getParagraphColor()"
                   [style.font-family]="getBodyFont()">"{{ testimonial.text }}"</p>
              </div>
              <h4 class="testimonial-author"
                  [style.color]="getPrimaryColor()"
                  [style.font-family]="getBodyFont()">{{ testimonial.author?.name }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="testimonials-nav" *ngIf="getTestimonials().length > 0">
        <button type="button"
                class="testimonials-nav-btn"
                (click)="scrollTestimonials('prev'); $event.stopPropagation()"
                [disabled]="!canScrollTestimonialsPrev()"
                aria-label="Previous testimonials">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button type="button"
                class="testimonials-nav-btn"
                (click)="scrollTestimonials('next'); $event.stopPropagation()"
                [disabled]="!canScrollTestimonialsNext()"
                aria-label="Next testimonials">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </section>

  <!-- Service Highlight Section -->
  <section class="service-highlight-section" 
           *ngIf="isElementVisible('services')"
           [class.selected]="getServicesElement()?.selected"
           [style.background-color]="getSectionBackgroundColor(getServicesElement())"
           (click)="onElementClick(getServicesElement())">
    <div class="service-container">
      <div class="service-content">
        <h2 class="service-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles(getServicesElement() || null)">{{ getTitleSafe(getServicesElement()) }}</h2>
        <p class="service-description"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getDescriptionSafe(getServicesElement()) }}</p>
        <button class="btn-primary"
                [style.background]="getPrimaryColor() || '#1B5BFF'"
                [style.--btn-bg]="getPrimaryColor() || '#1B5BFF'"
                [style.color]="getHeadingColor()"
                (click)="onButtonClick(getServicesElement()?.content?.buttonLink, $event)">
          <span class="btn-primary-text">{{ getServicesElement()?.content?.buttonText || 'Explore Services' }}</span>
          <span class="btn-primary-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </div>
      <div class="service-image">
        <img [src]="getServicesElement()?.content?.imageUrl || 'assets/images/service-placeholder.png'" 
             alt="Expert detailing" />
      </div>
    </div>
  </section>

  <!-- Booking Section -->

  <!-- Contact Section -->
  <section class="contact-section" 
           *ngIf="isElementVisible('contact')"
           [class.selected]="getContactElement()?.selected"
           [style.background-color]="getSectionBackgroundColor(getContactElement())"
           (click)="onElementClick(getContactElement()!)">
    <div class="contact-container">
      <h2 class="section-title"
          [ngStyle]="getTitleStyles(getContactElement() || null)">{{ getTitleSafe(getContactElement()) || 'Contact Us' }}</h2>
      <p class="section-description"
         *ngIf="getContactSubtitle()"
         [style.color]="getParagraphColor()"
         [style.font-family]="getBodyFont()">
        {{ getContactSubtitle() }}
      </p>
      <div class="contact-content">
        <div class="contact-details">
          <div class="contact-item">
            <strong>Address:</strong>
            <p>{{ getContactElement()?.content?.address || '123 Car Street, Auto City, USA' }}</p>
          </div>
          <div class="contact-item">
            <strong>Phone:</strong>
            <p>{{ getContactElement()?.content?.phone || '+1 234 567 890' }}</p>
          </div>
          <div class="contact-item">
            <strong>Email:</strong>
            <p>{{ getContactElement()?.content?.email || 'info@carwash.com' }}</p>
          </div>
          <div class="contact-item contact-hours" *ngIf="hasBusinessHours()">
            <strong>Operating Hours:</strong>
            <p *ngFor="let hours of getContactBusinessHours(); trackBy: trackByIndex" class="hours-line">
              <span *ngIf="hours.days">{{ hours.days }}</span>
              <span *ngIf="hours.day && !hours.days">{{ hours.day }}</span>
              <span *ngIf="(hours.days || hours.day) && (hours.time || hours.openTime)">: </span>
              <span *ngIf="hours.time">{{ hours.time }}</span>
              <span *ngIf="hours.openTime && !hours.time && !hours.closed">{{ hours.openTime }}</span>
              <span *ngIf="hours.closed">Closed</span>
            </p>
          </div>
        </div>
        <div class="contact-map">
          <iframe 
            *ngIf="getMapEmbedUrl()"
            [src]="getMapEmbedUrl()"
            class="map-iframe"
            frameborder="0"
            allowfullscreen
            loading="lazy">
          </iframe>
          <div *ngIf="!getMapEmbedUrl()" class="map-placeholder">
            <span>📍 Map Location</span>
          </div>
        </div>
      </div>
      <div class="social-links" *ngIf="getSocialLinks().length > 0">
        <a *ngFor="let link of getSocialLinks(); trackBy: trackByIndex" 
           [href]="link.link" 
           target="_blank" 
           class="social-link">
          {{ link.platform }}
        </a>
      </div>
    </div>
  </section>

  <!-- Booking Section -->
  <section class="booking-section" 
           *ngIf="isElementVisible('booking')"
           [class.selected]="getBookingElement()?.selected"
           [style.background-color]="getSectionBackgroundColor(getBookingElement())"
           (click)="onElementClick(getBookingElement())">
    <div class="booking-container">
      <!-- Layout 1: Default Light Theme (with external header) -->
      <div *ngIf="getBookingLayout(getBookingElement()!) === 'layout_1'">
        <h2 class="section-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()">{{ getTitleSafe(getBookingElement()) || 'Book Your Wash' }}</h2>
        <p class="section-subtitle"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getDescriptionSafe(getBookingElement()) || 'Schedule a convenient time for your next car wash.' }}</p>
        <app-booking-layout-1-preview
          [data]="getBookingLayoutData(getBookingElement()!)"
          [headingColor]="getHeadingColor()"
          [paragraphColor]="getParagraphColor()"
          [headingFont]="getHeadingFont()"
          [bodyFont]="getBodyFont()"
          [primaryColor]="getPrimaryColor()"
          [formData]="getBookingFormData(getBookingElement()!)"
          (formSubmit)="onBookingLayoutSubmit(getBookingElement()!, $event.formData, $event.event)"
          (fieldChange)="onBookingLayoutFieldChange(getBookingElement()!, $event.field, $event.value)"
          (dateTimeChange)="onBookingLayoutDateTimeChange(getBookingElement()!, $event.field, $event.dateTime)">
        </app-booking-layout-1-preview>
      </div>
      
      <!-- Layout 2: Dark Theme -->
      <app-booking-layout-2-preview
        *ngIf="getBookingLayout(getBookingElement()!) === 'layout_2'"
        [data]="getBookingLayoutData(getBookingElement()!)"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [formData]="getBookingFormData(getBookingElement()!)"
        (formSubmit)="onBookingLayoutSubmit(getBookingElement()!, $event.formData, $event.event)"
        (fieldChange)="onBookingLayoutFieldChange(getBookingElement()!, $event.field, $event.value)"
        (dateTimeChange)="onBookingLayoutDateTimeChange(getBookingElement()!, $event.field, $event.dateTime)">
      </app-booking-layout-2-preview>
    </div>
  </section>

  <!-- Footer Section -->
  <div class="website-element footer-element"
       *ngIf="isElementVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
  <app-modern-page-footer
    [quickLinks]="getFooterQuickLinks()"
    (quickLinkClick)="onNavigationClick($event)"
    [quickLinksTitle]="getFooterQuickLinksTitle()"
    [socialLinks]="getFooterSocialLinks()"
    [socialLinksTitle]="getFooterSocialLinksTitle()"
    [copyright]="getFooterCopyright()"
    [logo]="getFooterLogo()"
    [backgroundColor]="getFooterBackgroundColor()"
    [deviceType]="deviceType">
  </app-modern-page-footer>
  </div>
</div>
